import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';

import namespace from '../store/namespace';
import CompetitionsRoutes from './competitions';
import EventRegistrationRoutes from './eventregistrations';

import Login from '../auth/Login.vue';
import Register from '../auth/Register.vue';
import Confirm from '../auth/Confirm.vue';
import ForgotPassword from '../auth/ForgotPassword.vue';
import ResetPassword from '../auth/ResetPassword.vue';
import Dashboard from '../dashboard/Dashboard.vue';

Vue.use(Router);

const router = new Router({
	mode: 'history',
	routes: [{
		path: '/login',
		name: 'login',
		component: Login,
	}, {
		path: '/register',
		name: 'register',
		component: Register,
	}, {
		path: '/forgotpassword',
		name: 'forgotpassword',
		component: ForgotPassword,
	}, {
		path: '/resetpassword',
		name: 'resetpassword',
		component: ResetPassword,
	}, {
		path: '/confirm',
		name: 'confirm',
		component: Confirm,
	}, {
		path: '/dashboard',
		name: 'dashboard',
		component: Dashboard,
	}, {
		path: '*',
		redirect: '/dashboard',
	}].concat(CompetitionsRoutes)
		.concat(EventRegistrationRoutes),
});

router.beforeEach((to, _from, next) => {
	const { requiresAuth } = to.meta;

	if (requiresAuth) {
		const isAuthenticated = store.getters[`${namespace.AUTH}/IsAuthenticated`];

		if (!isAuthenticated) {
			return next({
				path: '/login',
				query: { redirect: to.fullPath },
			});
		}
		return next();
	}

	return next();
});

export default router;
